import React from "react";
import { AgentPartnerProductCard } from "./agent-partner-product-card";
import { lobToCardInfo, ProductCardInfo } from "../pages/agent-partner-select/agent-partner-select";
import { cyberCardInfo } from "../config/partner-config/agent-partner-select-constants";

interface AgentProductsSectionProps {
  productsData: lobToCardInfo[];
  showProducts: boolean;
  setShowAlert?: (show: boolean) => void;
  setAlertMessage?: (message: { title: string; message: string }) => void;
  waitForUserConfirmation?: (partnerInfo: ProductCardInfo) => Promise<void>;
}

export const AgentProductsSection: React.FC<AgentProductsSectionProps> = ({
  productsData,
  showProducts,
  setShowAlert = () => {},
  setAlertMessage = () => {},
  waitForUserConfirmation = () => Promise.resolve(),
}) => {
  return (
    <div>
      <h2 className="agent-partner-select-products-header">
        Business Insurance Products
      </h2>
      <p className="agent-partner-select-products-sub-header">
        Based on the customer's business, it looks like they could use:
      </p>
      {showProducts && (
        <div>
          {productsData
            .filter((product) => product.isEnabled)
            .map((product, index) => (
              <AgentPartnerProductCard
                key={product.lobName}
                showProducts={true}
                cardInfo={product}
                setShowAlert={setShowAlert}
                setAlertMessage={setAlertMessage}
                waitForUserConfirmation={waitForUserConfirmation}
              />
            ))}
          <AgentPartnerProductCard
            showProducts={true}
            cardInfo={cyberCardInfo[0]}
          />
        </div>
      )}
      {!showProducts && (
        <div>
          <AgentPartnerProductCard showProducts={false} />
        </div>
      )}
    </div>
  );
};
